<div [attr.data-test-id]="'rapidReviewDx' + diagnosis.personDiagnosisId">
	<p><strong>{{ diagnosis.code }} -</strong> {{ diagnosis.description }} <strong>(Dx Date: {{ diagnosis.diagnosisDate | date:dateFormat }})</strong></p>
	@if (diagnosis.carePlanItems.length > 0) {
		<div class="mrgn-btm">
			<ag-grid-angular
				class="ag-theme-alpine ag-grid-compact"
				pmsAgAutoFitColumns
				[rowData]="diagnosis.carePlanItems"
				[columnDefs]="gridColumns"
				[pagination]="false">
			</ag-grid-angular>
		</div>
	}
</div>
